<script setup lang="ts">
import { inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const isClose = dialogRef?.value?.options?.emits?.isClose;
const dataWrong = dialogRef?.value?.options?.data?.dataWrong;

const { t } = useI18n({ useScope: 'global' });
</script>
<template>
  <div class="not_found_modal pt-2 text-center">
    <div class="notice mb-2 font-bold text-primary">{{ t('management.tour.confirm.notice') }}</div>
    <div class="update mb-2 mt-4 font-bold text-primary">{{ t('management.tour.confirm.update_tour_detail') }}</div>
    <div class="list_not_found font-bold text-primary">{{ t('management.tour.confirm.list_tts_not_found') }}</div>
    <div class="list_id flex grid my-2" v-for="(data, index) in dataWrong" :key="index">
      <div class="font-bold">{{ t('common.option') }}: {{ data.option + 1 }}</div>
      <div class="col-12" v-for="(tour, tourIndex) in data.tourLog" :key="tourIndex">
        <div class="flex flex-wrap">
          <div class="col-6 font-bold">{{ t('common.ttsId') }}: {{ tour.detail?.ttsId }}</div>
          <div class="col-6 font-bold">{{ t('common.svId') }}: {{ tour.detail?.svId }}</div>
        </div>
      </div>
    </div>
    <Button id="btn-close" @click="isClose()">{{ t('common.buttons.close') }}</Button>
  </div>
</template>
<style lang="scss" scoped>
.not_found_modal {
  width: min(500px, 65vw);
}
</style>
